 
import {
  clearBannerData,
  getBannerDataFail,
  getBannerDataStarted,
  getBannerDataSuccess
} from '../../../reducer/schedule-maintenance/GetBannerDataReducer';
import { getBannerData } from '../../actionType/schedule-maintenance/GetBannerDataTypes';
import {
  ClearGetBannerData,
  GetBannerDataFailure,
  GetBannerDataFailurePayload,
  GetBannerDataRequest,
  GetBannerDataStarted,
  GetBannerDataSuccess,
  GetBannerDataSuccessPayload
} from '../../types/schedule-maintenance/GetBannerDataTypes';

export const getBannerDataRequest = (): GetBannerDataRequest => ({
  type: getBannerData.FETCH_BANNER_DATA_REQUEST,
});

/**
 * get metric summary started saga action
 * @returns get metric summary action
 */
export const getBannerDataStart = (): GetBannerDataStarted => ({
  type: getBannerDataStarted.type
});

/**
 * Get metric summary success saga action
 * @param payload :Metric data
 * @returns success action
 */
export const getBannerDataSuccessful = (
  payload: GetBannerDataSuccessPayload
): GetBannerDataSuccess => ({
  type: getBannerDataSuccess.type,
  payload
});

/**
 * get metric Failed saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const getBannerDataFailure = (
  payload: GetBannerDataFailurePayload
): GetBannerDataFailure => ({
  type: getBannerDataFail.type,
  payload
});

/**
 * Clear metrics saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const cleargetBannerData = (): ClearGetBannerData => ({
  type: clearBannerData.type
});
